import { render, staticRenderFns } from "./xinghaojlSpReform.vue?vue&type=template&id=12b4a2b2"
import script from "./xinghaojlSpReform.vue?vue&type=script&lang=js"
export * from "./xinghaojlSpReform.vue?vue&type=script&lang=js"
import style0 from "./xinghaojlSpReform.vue?vue&type=style&index=0&id=12b4a2b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports